import { useUserStore } from '@/rennovation/planning-view/store';

export const resolveUserDisplayName = (userId: string | null | undefined): string => {
	if (!userId) return '-';
	const userStore = useUserStore();
	return userStore.getUserById(userId)?.displayName ?? '-';
};
